export default class EmailAdminConstants {
  static readonly EmapleExamplehlperText = 'ex:abc@example.com;xyz@example.com';
  static readonly MailIgnoreMessage = 'Ignored this email since it is invalid';
  static readonly EmailSentSuccessfully = 'Emails Sent Successfully';
  static readonly EmailEmptyWarning =
    'Atlease one recipient has to be provided';
  static readonly CcHelperText =
    "Can provide multiple emails, seperate them by ';'";
}
